import { StorageSerializers, useLocalStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

/**
 * Presentation mode settings.
 */
export const usePresentationModeStore = defineStore('presentationMode', {
    state: () => ({
        _enabled: useLocalStorage<boolean>('presentationModeEnabled', false, { serializer: StorageSerializers.boolean }),
        _hideName: true,
        _hideSalary: true,
        _hidePerformance: true
    }),
    getters: {
        enabled: (state): boolean => state._enabled,
        hideName: state => state._enabled && state._hideName,
        hidePerformance: state => state._enabled && state._hidePerformance,
        hideSalary: state => state._enabled && state._hideSalary
    },
    actions: {
        /** Turn presentation mode on/off. */
        setEnabled(val: boolean) {
            this._enabled = val;
        },
        setHideName(val: boolean) {
            this._hideName = val;
        },
        setHidePerformance(val: boolean) {
            this._hidePerformance = val;
        },
        setHideSalary(val: boolean) {
            this._hideSalary = val;
        }
    }
});
